import {
  REFER_A_FRIEND,
  REFER_A_FRIEND_SUCCESS,
  REFER_A_FRIEND_ERROR,
} from './referralCodeActionConstants';

// refer a friend button clicked
export const postReferAFriend = (payload) => ({
  type: REFER_A_FRIEND,
  payload,
});

export const postReferAFriendSuccess = (payload) => ({
  type: REFER_A_FRIEND_SUCCESS,
  payload,
});

export const postReferAFriendError = (payload) => ({
  type: REFER_A_FRIEND_ERROR,
  payload,
});
